import { Colors, Services } from '@sigma-frontend-libs/commons'

import { buttonModes, components, icons } from '@/utils'

import button from '@/components/button'
import info from '@/components/info'
import sticker from '@/components/sticker'

function renderSimilarDialogBody(h) {
  return h(
    'div',
    {
      class: 'grid grid-gap--8 px-2'
    },
    [
      h(
        info,
        {
          props: {
            value: this.getTranslate(`${Services.tariffs}.contents.similar`),
            color: Colors.warning
          }
        }
      ),

      h(
        'div',
        {
          class: 'grid grid-gap--8 grid-cols--2'
        },
        this.similarTariffs.map(tariff => {
          return h(
            sticker,
            {
              props: {
                value: tariff.title,
                label: this.getTranslate(`${Services.tariffs}.tariff`),
                to: {
                  name: `${Services.tariffs}.single`,
                  params: { id: tariff.id }
                },
                target: '_blank'
              }
            }
          )
        })
      )
    ]
  )
}
function renderSimilarDialogFooter(h) {
  return h(
    'div',
    {
      class: 'dialog__footer',
      slot: 'footer'
    },
    [
      h(
        button,
        {
          props: {
            label: this.getTranslate('misc.buttons.close'),
            mode: buttonModes.flat,
            icon: icons.close
          },
          on: {
            click: () => {
              this.showSimilarDialog = false
              this.showConfirmDialog = false
              this.similarTariffs = []
            }
          }
        }
      ),
      h(
        button,
        {
          props: {
            label: this.getTranslate('misc.buttons.create'),
            icon: icons.done,
            color: Colors.primary,
            disabled: !this.cloneActionsAreAvailable
          },
          on: {
            click: () => {
              this.createTariff(this.processPayload(this.divideByHundred))
            }
          }
        }
      )
    ]
  )
}
function renderSimilarDialog(h) {
  let similarDialogMaxWidth
  if (this.viewport.breakpoint.mdUp) {
    similarDialogMaxWidth = 400
  }

  return h(
    components.dialog,
    {
      props: {
        value: this.showSimilarDialog,
        title: this.getTranslate(`${Services.tariffs}.titles.similar`),
        maxWidth: similarDialogMaxWidth
      },
      on: {
        input: event => {
          if (event === false) {
            this.showConfirmDialog = false
            this.similarTariffs = []
          }
          this.showSimilarDialog = event
        }
      }
    },
    [
      renderSimilarDialogBody.call(this, h),
      renderSimilarDialogFooter.call(this, h)
    ]
  )
}

function renderConfirmDialogBody(h) {
  let confirmCloneKey
  if (this.divideByHundred) {
    confirmCloneKey = 'divided'
  } else {
    confirmCloneKey = 'simple'
  }

  return h(
    'div',
    { class: 'grid grid-gap--8 px-2' },
    [
      h(
        info,
        {
          props: {
            value: this.getTranslate(`${Services.tariffs}.contents.confirm.clone.${confirmCloneKey}`)
          }
        }
      )
    ]
  )
}
function renderConfirmDialogFooter(h) {
  return h(
    'div',
    {
      class: 'dialog__footer',
      slot: 'footer'
    },
    [
      h(
        button,
        {
          props: {
            label: this.getTranslate('misc.buttons.close'),
            icon: icons.close,
            mode: buttonModes.flat
          },
          on: {
            click: () => {
              this.showConfirmDialog = false
            }
          }
        }
      ),
      h(
        button,
        {
          props: {
            label: this.getTranslate('misc.buttons.confirm'),
            icon: icons.done,
            color: Colors.success,
            disabled: !this.cloneActionsAreAvailable
          },
          on: {
            click: () => {
              this.cloneTariff(this.divideByHundred)
              this.showConfirmDialog = false
            }
          }
        }
      )
    ]
  )
}
function renderConfirmDialog(h) {
  let confirmDialogMaxWidth
  if (this.viewport.breakpoint.mdUp) {
    confirmDialogMaxWidth = 400
  }

  return h(
    components.dialog,
    {
      props: {
        value: this.showConfirmDialog,
        title: this.getTranslate(`${Services.tariffs}.titles.confirm.clone`),
        maxWidth: confirmDialogMaxWidth
      },
      on: {
        input: event => {
          if (event === false) {
            this.divideByHundred = false
          }
          this.showConfirmDialog = event
        }
      }
    },
    [
      renderConfirmDialogBody.call(this, h),
      renderConfirmDialogFooter.call(this, h)
    ]
  )
}

export default function(h) {
  if (this.checkPermissions(`advanced.${Services.tariffs}.create`)) {
    return h(
      'div',
      {
        class: `${Services.tariffs}-buttons-double`
      },
      [
        h(
          button,
          {
            props: {
              tooltip: this.getTranslate(`${Services.tariffs}.tooltips.clone.simple`),
              icon: icons.add,
              color: Colors.primary,
              mode: buttonModes.flat,
              loading: this.loading,
              disabled: !this.cloneActionsAreAvailable
            },
            on: {
              click: () => {
                this.showConfirmDialog = true
              }
            }
          }
        ),

        h(
          button,
          {
            props: {
              label: this.getTranslate(`${Services.tariffs}.buttons.clone.divided`),
              tooltip: this.getTranslate(`${Services.tariffs}.tooltips.clone.divided`),
              mode: buttonModes.flat,
              icon: icons.add,
              color: Colors.primary,
              loading: this.loading,
              disabled: !this.cloneActionsAreAvailable
            },
            on: {
              click: () => {
                this.divideByHundred = true
                this.showConfirmDialog = true
              }
            }
          }
        ),

        renderSimilarDialog.call(this, h),
        renderConfirmDialog.call(this, h)
      ]
    )
  }
}
